import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useInView } from '../hooks/useInView';
export function PromiseAndCtaSection() {
  const {
    ref,
    isVisible
  } = useInView();
  return <section id="offer" ref={ref} className="w-full bg-navy py-12 px-6 md:py-20 text-center" data-id="element-158">
      <div className={`max-w-2xl mx-auto fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-159">
        {/* Promise */}
        <div className="mb-10" data-id="element-160">
          <h2 className="font-serif text-3xl md:text-4xl text-gold mb-6" data-id="element-161">
            La promesa realista
          </h2>
          <div className="font-sans text-lg md:text-xl text-white/90 leading-relaxed space-y-3" data-id="element-162">
            <p data-id="element-163">No te voy a prometer una vida perfecta.</p>
            <p data-id="element-164">Te prometo algo más útil:</p>
            <p className="font-serif text-2xl md:text-3xl text-white italic py-2" data-id="element-165">
              Que en 14 días vas a contar con una estructura clara para manejar
              el diálogo interno del día a día, con más orden mental y menos
              desgaste.
            </p>
          </div>
        </div>

        {/* Final CTA */}
        <div className="p-6 md:p-8 rounded-2xl border border-gold/30 bg-white/5" data-id="element-166">
          <p className="font-serif text-xl text-white mb-6" data-id="element-167">
            Si hoy estás cansada de ser tu propia jueza, entra aquí:
          </p>

          <button className="w-full md:w-auto bg-gold hover:bg-gold/90 text-navy font-bold py-5 px-10 rounded-lg shadow-[0_0_30px_rgba(201,168,76,0.4)] transition-all hover:scale-[1.02] flex items-center justify-center gap-3 text-xl mx-auto" data-id="element-168">
            Quiero Conocer la Guía — US$6.39
            <ArrowRight className="w-6 h-6" data-id="element-169" />
          </button>

          <div className="mt-4 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-white/60 text-sm font-sans" data-id="element-170">
            <span data-id="element-171">Descarga inmediata</span>
            <span className="hidden md:inline" data-id="element-172">·</span>
            <span data-id="element-173">14 días</span>
            <span className="hidden md:inline" data-id="element-174">·</span>
            <span data-id="element-175">10 min al día</span>
          </div>
        </div>
      </div>
    </section>;
}